import { Injectable } from "@angular/core"
import { Actions, Effect } from "@ngrx/effects"
import { Action } from "@ngrx/store"
import { Contact } from "@models/contact"
import { Observable } from "rxjs/Observable"
import { ContactService } from "@services/contact"
import { RoleService } from "@services/role";
import {
  FETCH_CURRENT_USER_CONTACT,
  POPULATE_CURRENT_USER_CONTACT,
  FETCH_CURRENT_USER_CONTACT_FAILURE,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAILURE,
  REPLACE_USER
} from "../user"
import { Angular2TokenService } from 'angular2-token';
import { User } from "@models/user";

@Injectable()
export class UserEffects {

  constructor(
    private actions: Actions,
    private contactService: ContactService,
    private roleService: RoleService,
    private tokenService: Angular2TokenService,
  ) {}

  @Effect() login = this.actions
    .ofType(LOGIN)
    .map((action: Action) => action.payload)
    .switchMap((credentials: any) => {
      return this.tokenService.signIn(credentials)
        .map((res: any) => ({ type: LOGIN_SUCCESS, payload: res }))
        .catch((err: any) => Observable.of({ type: LOGIN_FAILURE, payload: err })) }
    )

  @Effect() update = this.actions
    .ofType(UPDATE_USER)
    .map((action: Action) => action.payload)
    .switchMap((user: User) => this.roleService.updateUser(user.serializeForRails())
      .map((user: User) => ({ type: REPLACE_USER, payload: user }))
      .catch((response: any) => Observable.of({ type: UPDATE_USER_FAILURE, payload: response }))
    )
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/user.ts